export const messages = {
  en: {
    more: 'More',
    close: 'Close',
    empty: 'Nothing Found',
    filter: 'FAQ Search',
    'bring-your-own-smartphone-byop': 'BYOP',
    '5g': '5G',
    'getting-started': 'Gettting Started',
    'general-questions': 'General Questions',
    'unlimited-plans': 'Unlimited Plans',
    idnotify: 'IDnotify',
    'phone-devices': 'Phone/Devices',
    'my-account-app': 'My Account App',
    'phone-upgrades': 'Phone Upgrades',
    'mobile-protect': 'Mobile Protect',
    troubleshooting: 'Troubleshooting',
    'general-information': 'General Information',
    '611611-services': '611611 Services',
    features: 'Features',
    'policies-and-procedures': 'Policies & Procedures',
    products: 'Products',
    'international-long-distance': 'International Long Distance',
    'transfer-number': 'Transfer Number',
    services: 'Services',
    'device-trade-in': 'Device Trade-In',
    'interactive-tutorials': 'Interactive Tutorials'
  },
  'es-ud': {
    more: 'Más',
    close: 'Cerrar',
    empty: 'Nada Encontrado',
    filter: 'Filtro De Contenido'
  },
  es: {
    more: 'Más',
    close: 'Cerrar',
    empty: 'Nada Encontrado',
    filter: 'Filtro De Contenido'
  }
}



// WEBPACK FOOTER //
// ./src/components/ExpressHelp/messages.js